export const cssBundleHref = "/build/css-bundle-HY752XRP.css";